import { render, staticRenderFns } from "./draggableTable.vue?vue&type=template&id=316d942b&"
import script from "./draggableTable.vue?vue&type=script&lang=js&"
export * from "./draggableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports